import {
  Box,
  Button,
  CardMedia,
  Dialog,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik, setNestedObjectValues } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  sendOtp,
  verifyPan,
  EnablePOA,
  IsApplicableForPOA,
  SendEmail,
  AcknowledgeAmlCheck,
  sendConsentEmail,
  verifyApplicant,
  DoCkyc,
} from '../../redux-store/actions/onBoarding';
import {
  AcknowledgeAmlCheckResponseBody,
  AmlSystemMatch,
  ApplicationProps,
  DistributorListType,
  EnablePOAResponseBody,
  IsApplicableForPOAResponseBody,
  SendCkycPayload,
  SendCkycResponse,
  SendConsentEmailResponseBody,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
  VerifyPanResponseBody,
} from '../../redux-store/types/api-types';
import CloseIcon from '@mui/icons-material/Close';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import {
  emailRegex,
  individualPanRegex,
  nonDigitRegex,
  nonIndividualPanRegex,
  phoneRegExp,
} from '../../utils/regex';
import { Location } from 'history';
import { Notes } from '../investors/components';
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  futureAge,
  getCountryCodes,
  getFirstHolderName,
  isCvlProvider,
  isMinor,
  isOnboardingTypeMinor,
  maxAge,
  openUrl,
  preventSpecialCharacters,
} from '../../utils/utilityFunctions';
import {
  AML_ALL_DISPLAY_MODE,
  APPLICATION_TYPE,
  ENABLE_Email_Consent,
  ENABLE_EMAIL_OTP,
  IS_DOB_APPLICABLE_FOR_AMC,
  KRA_STATUS_MASTER,
  ONBOARDING_OPTIONS,
  onboardingTypeMasters,
  USER_ROLES,
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { AmlPopup, AmlPopupValues, MobileNumberField } from '../commonComponents';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import { TextDatePicker } from '../../lib/formik/DatePickerWithTextFeild';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { distType, FundProps } from '../../redux-store/types/funds';
import { getDirectApplicableFunds, getDist } from '../../redux-store/actions/funds';
import { getDistributorById } from '../../redux-store/actions/userManagement';
import { getUserInfo, showError } from '../../redux-store/actions/auth';
import MFSelectField from '../../lib/formik/SelectField';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface Values {
  pan: string;
  dob: string;
  onboardingType: string;
  schemeId: string;
}

interface MValues {
  pan: string;
  mobile?: string;
  bypassOtp: boolean;
  skipOtpModal: boolean;
  emailId: string;
  hasPOA: boolean;
  dob: string;
  countryCode: string;
  countryNameAndCode: string;
  onboardingOtpEmailConsent?: string;
  kycStatus: string;
  kraVerification: string;
  name: string;
  aadhaarLinked: boolean;
}
interface EValues {
  pan: string;
  emailId: string;
  dob: string;
  hasPOA: boolean;
  kycStatus: string;
  kraVerification: string;
  name: string;
  countryCode: string;
  countryNameAndCode: string;
  mobile?: string;
}

export default function EnterPAN({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
    index?: number;
    fromTopUp?: boolean;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    firstHolderName = '',
    application,
    index,
    fromTopUp,
  } = location.state || {};
  const { id, applicants = [], hasPOA, schemeId = '' } = application || {};
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [amlPopup, setAmlPopup] = React.useState<{
    panVerificationToken: string;
    pan: string;
    dob: string;
  } | null>(null);
  const [amlFailedresponse, setAmlFailedresponse] = React.useState<AmlSystemMatch>();
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = React.useState(false);
  const [verifyPanLoading, setVerifyPanLoading] = React.useState(false);
  const [topUpLoader, setTopUpLoader] = useState(false);
  const [fundData, setFundData] = useState<FundProps[]>([]);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const applicantPanNumbers = applicants.map((applicant) => applicant.panNo);
  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        const isPANWithP = fieldValue[3] === 'P';
        const isMinorOnboarding = isOnboardingTypeMinor(parent.onboardingType);
        if (isPANWithP) {
          if (!individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'Invalid PAN',
              path,
            });
          }
          if (applicantPanNumbers.includes(fieldValue) && !application?.topupInitiated) {
            return createError({
              message:
                'There is already the same PAN for an applicant associated with this application',
              path,
            });
          }
        } else if (
          !nonIndividualPanRegex.test(fieldValue) ||
          (nonIndividualPanRegex.test(fieldValue) && isMinorOnboarding)
        ) {
          return createError({
            message: 'Invalid PAN',
            path,
          });
        }
        return true;
      }),
    dob: yup
      .string()
      .nullable()
      .test('dob', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (IS_DOB_APPLICABLE_FOR_AMC) {
          if (!fieldValue) {
            return createError({
              message: 'Date of birth is required',
              path,
            });
          } else if (
            futureAge(fieldValue) ||
            fieldValue.toString().toLowerCase() === 'Invalid date'
          ) {
            return createError({
              message: 'Invalid Date',
              path,
            });
          } else if (isMinor(fieldValue) && parent.pan?.split('')[3] === 'P') {
            return createError({
              message: 'Age should be greater than 18',
              path,
            });
          } else if (maxAge(fieldValue) && parent.pan?.split('')[3] === 'P') {
            return createError({
              message: 'Age should be less than 130',
              path,
            });
          }
        }

        return true;
      }),
    schemeId: yup.string().nullable().required('Fund Scheme is required'),
  });
  const [panVarificationResponse, setPanVarificationResponse] =
    React.useState<VerifyPanResponseBody>();
  const initialValues1: Values = {
    pan: '',
    dob: '',
    onboardingType: 'normal',
    schemeId: schemeId ? schemeId : '',
  };
  const [onboardingData, setOnboardingData] = useState(initialValues1);

  useEffect(() => {
    (async () => {
      setTopUpLoader(true);
      try {
        if (application && application?.topupInitiated) {
          setOnboardingData({
            ...onboardingData,
            pan: applicants[index || 0].panNo || '',
            dob: applicants[index || 0].dateOfBirth || '',
            onboardingType: applicants[index || 0].onboardingType || '',
            schemeId: application.schemeId || '',
          });
        }
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        setTopUpLoader(false);
      }
    })();
  }, []);

  const routingAfterPanVerification = async (
    response: VerifyPanResponseBody | (VerifyPanResponseBody & AcknowledgeAmlCheckResponseBody),
    pan: string,
    dob: string,
    values: Values
  ) => {
    try {
      const isCvl = isCvlProvider(fundData?.find((f) => f.id == values?.schemeId)?.kraName || '');
      if (response?.kraVerificationError && isCvl) {
        throw response?.kraVerificationError;
      }
      if (response?.kraVerification !== 'success' && isCvl) {
        throw 'KRA verification failed. Please contact admin';
      }
      if (hasPOA && !application.topupInitiated) {
        const { panVerificationToken } = response || {};
        if (['kraonhold', 'not_kyc', 'kraregistered', ''].includes(response?.kycStatus)) {
          history.push('enter-mobile-number', {
            pan: pan.toUpperCase(),
            dob: dob,
            ...(response || {}),
            redirectTo,
            firstHolderName,
            application,
            powerOfAttorney: true,
            index,
            fromTopUp,
          });
          return;
        }
        const poaResponse = (await dispatch(
          EnablePOA({ panVerificationToken, powerOfAttorney: true })
        )) as unknown as EnablePOAResponseBody;
        const { applicantVerificationToken } = poaResponse;
        await dispatch(addJointHolder({ applicantVerificationToken }, id));
        history.push(redirectTo, { id });
        return;
      }
      //need to fetch POA status here due to multiple calls happening when network goes offline in enter mobile/emailid  screen
      const res = (await dispatch(
        IsApplicableForPOA()
      )) as unknown as IsApplicableForPOAResponseBody;
      const { powerOfAttorney } = res;
      if (response.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) {
        return history.push('enter-email-id', {
          pan: pan.toUpperCase(),
          dob: dob,
          ...(response || {}),
          powerOfAttorney,
          application,
          index,
          fromTopUp,
        });
      }
      history.push('enter-mobile-number', {
        pan: pan.toUpperCase(),
        dob: dob,
        ...(response || {}),
        redirectTo,
        firstHolderName,
        application,
        powerOfAttorney,
        index,
        fromTopUp,
      });
    } catch (e) {
      console.error((e as Error).message);
      typeof e === 'string' && dispatch(showError(e));
    }
  };

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        let user;
        if (!application?.distributor_id && ['distributor', 'subdistributor'].includes(role)) {
          user = (await dispatch(getDist())) as unknown as distType;
        }
        const res =
          application?.distributor_id || ['distributor', 'subdistributor'].includes(role)
            ? ((
                (await dispatch(
                  getDistributorById(
                    application?.distributor_id
                      ? application?.distributor_id
                      : user?.distributorId || ''
                  )
                )) as unknown as DistributorListType
              ).planDetails.schemes as FundProps[])
            : ((await dispatch(
                getDirectApplicableFunds({ isActive: true })
              )) as unknown as FundProps[]);
        if (!isComponentActive) return;
        setFundData(res);
      } catch (e) {
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  const handleSubmit1 = async (values: Values) => {
    try {
      setVerifyPanLoading(true);
      const { pan, dob, onboardingType, schemeId } = values;
      setOnboardingData(values);
      const response = (await dispatch(
        verifyPan({ pan, dob, onboardingType, schemeId })
      )) as unknown as VerifyPanResponseBody;
      if (!response.amlCheck) {
        setPanVarificationResponse(response);
        const { system_match = [], referral_match = [] } = response.amlData || {};
        const matches = AML_ALL_DISPLAY_MODE
          ? [...system_match, ...referral_match]
          : [system_match[0] || referral_match[0]].filter(Boolean);
        setAmlFailedresponse(
          matches.length
            ? {
                ...matches[0],
                FURTHER_INFORMATION: matches
                  .map((m) => m.FURTHER_INFORMATION)
                  .filter(Boolean)
                  .join('\n\n'),
                EXTERNAL_SOURCES: matches
                  .map((m) => m.EXTERNAL_SOURCES)
                  .filter(Boolean)
                  .join('\n'),
              }
            : undefined
        );
        return setAmlPopup({
          panVerificationToken: response.panVerificationToken,
          pan: pan,
          dob: dob,
        });
      }
      routingAfterPanVerification(response, pan, dob, values);
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setVerifyPanLoading(false);
    }
  };
  const handleClose = () => {
    setAmlPopup(null);
  };

  const onSubmit = async (values: AmlPopupValues) => {
    try {
      setVerifyPanLoading(true);
      setAmlAcknowledgementLoading(true);
      const { amlComments, amlAcknowledgement } = values;
      const { panVerificationToken = '', pan = '', dob = '' } = amlPopup || {};
      setAmlPopup(null);
      const response = (await dispatch(
        AcknowledgeAmlCheck({ panVerificationToken, amlComments, amlAcknowledgement })
      )) as unknown as AcknowledgeAmlCheckResponseBody;
      routingAfterPanVerification(
        { ...panVarificationResponse, ...response } as VerifyPanResponseBody &
          AcknowledgeAmlCheckResponseBody,
        pan,
        dob,
        onboardingData
      );
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setVerifyPanLoading(false);
      setAmlAcknowledgementLoading(false);
    }
  };
  return (
    <>
      <Formik
        initialValues={onboardingData}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}
        enableReinitialize={true}>
        {({ handleSubmit, resetForm, values }) => (
          <>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <UseRadioGroup
                disabled={id ? true : false}
                formLabel="Investor Type*"
                name="onboardingType"
                items={Object.keys(onboardingTypeMasters).map((type) => ({
                  value: type,
                  label: onboardingTypeMasters[type],
                }))}
              />
              {isOnboardingTypeMinor(values.onboardingType) && (
                <Box
                  sx={{
                    '& .MuiSvgIcon-root': { display: 'none' },
                    '& .MuiTypography-root': { ml: 0 },
                  }}>
                  <Notes
                    displayContent={
                      'You have selected Minor Investor Onboarding. Please provide Guardian PAN and Date of Birth'
                    }
                  />
                </Box>
              )}
              <MFTextField
                label={isOnboardingTypeMinor(values.onboardingType) ? 'Guardian PAN' : 'PAN'}
                name="pan"
                placeholder="Enter PAN"
                required
                autoComplete="off"
                inputProps={{ style: { textTransform: 'uppercase' } }}
                disabled={application?.topupInitiated || false}
              />
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <TextDatePicker
                  label={
                    isOnboardingTypeMinor(values.onboardingType)
                      ? 'Guardian Date of Birth'
                      : 'Date of Birth/Incorporation'
                  }
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'DD/MM/YYYY'}
                  name="dob"
                  disabled={application?.topupInitiated || false}
                />
              )}
              <SearchableSelect
                name="schemeId"
                label="Fund (Scheme)"
                items={(fundData as FundProps[])
                  ?.sort((rm1, rm2) =>
                    (rm1['schemeName'] || '')
                      .toString()
                      .localeCompare((rm2['schemeName'] || '').toString())
                  )
                  .map((item) => ({
                    key: item.schemeName,
                    value: item.id,
                  }))}
                searchFieldPlaceholder={'Search Fund'}
                disabled={Boolean(schemeId)}
              />
              <MFSubmitButton
                label="Verify PAN"
                loadingEnable={amlAcknowledgementLoading || topUpLoader || verifyPanLoading}
              />
              <Notes
                displayContent={
                  'Add the applicant(s) PAN and if the PAN is KRA verified, the contact details will be populated automatically. Pan will be checked against World-Check database for AML compliance.'
                }
              />
            </Box>
            <Dialog open={open} onClose={() => setOpen(false)}>
              <Box
                sx={{
                  p: { xs: 2, sm: 8 },
                  borderRadius: '10px',
                  // width: { xs: '70%', sm: '70%' },
                  maxWidth: 800,
                  height: { xs: '90%', md: 'unset' },
                  overflowY: 'auto',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .MuiButton-root': {
                      minWidth: 200,
                      fontSize: 16,
                    },
                  }}>
                  <Box sx={{ mb: 8 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: '#337FC9',
                      textAlign: 'center',
                      width: '70%',
                      mb: 5,
                    }}>
                    Unable to verify the details please contact admin
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => {
                      resetForm();
                      setOpen(false);
                    }}
                    sx={{ color: 'common.white' }}>
                    Enter another PAN
                  </Button>
                </Box>
              </Box>
            </Dialog>
            <AmlPopup
              handleClose={handleClose}
              amlPopupOpen={amlPopup !== null}
              onSubmit={onSubmit}
              FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
              EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
              displayDocInfo={true}
            />
          </>
        )}
      </Formik>
    </>
  );
}

export const KYCCompletionLink = ({ ckycRedirectUrl }: { ckycRedirectUrl?: string }) => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  if (
    !ckycRedirectUrl ||
    ![
      USER_ROLES.RM,
      USER_ROLES.DISTRIBUTOR,
      USER_ROLES.SUBDISTRIBUTOR,
      USER_ROLES.AMC_ADMIN,
    ].includes(role)
  )
    return null;

  return (
    <Stack
      spacing={1}
      sx={{
        backgroundColor: 'rgba(51, 127, 201, 0.04)',
        border: '1px solid rgba(51, 127, 201, 0.2)',
        borderRadius: 2,
        padding: 2,
        boxSizing: 'border-box',
      }}>
      {/* Header */}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle2" fontWeight={600}>
          KYC Completion Link (For Client)
        </Typography>

        <Stack direction="row" spacing={0.5}>
          {/* Open Link */}
          <Tooltip title="Open link in new tab">
            <IconButton size="small" onClick={() => openUrl(ckycRedirectUrl)}>
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          {/* Copy Link */}
          <Tooltip title="Copy link">
            <IconButton size="small" onClick={() => navigator.clipboard.writeText(ckycRedirectUrl)}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      {/* URL Display */}
      {ckycRedirectUrl && (
        <Tooltip title={ckycRedirectUrl}>
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              backgroundColor: '#fff',
              border: '1px dashed',
              borderColor: 'divider',
              borderRadius: 1,
              px: 1.5,
              py: 1,
              cursor: 'default',
            }}>
            <Typography
              variant="body2"
              sx={{
                // Basic setup
                color: 'text.secondary',
                width: '100%',

                // Multi-line truncation logic
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 4, // Shows exactly 4 lines then "..."
                overflow: 'hidden',
                wordBreak: 'break-all', // Ensures long URLs without spaces actually wrap
              }}>
              {ckycRedirectUrl}
            </Typography>
          </Stack>
        </Tooltip>
      )}
    </Stack>
  );
};
export function EnterMobile({
  location,
}: {
  location: Location<{
    redirectTo: string;
    panVerificationToken: string;
    pan: string;
    firstHolderName: string;
    application: ApplicationProps;
    dob: string;
    amlCheck: boolean;
    powerOfAttorney: boolean;
    index: number;
    fromTopUp?: boolean;
    kycStatus: string;
    kraVerification: string;
    aadhaarLinked: boolean;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    panVerificationToken,
    pan,
    firstHolderName = '',
    application,
    dob,
    amlCheck = false,
    powerOfAttorney = false,
    index = 0,
    kycStatus = '',
    kraVerification = '',
    fromTopUp = false,
    aadhaarLinked = false,
  } = location.state || {};
  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);
  // eslint-disable-next-line
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const [kraDetailsCaptured, setKraDetailsCaptured] = useState(false);
  const [ckycResponse, setCkycResponse] = useState<SendCkycResponse>({
    ckycId: null,
    redirectUrl: '',
  });
  const [kraFailuer, setKraFailuer] = useState(false);

  // 🔥 Open dialog immediately on page load
  useEffect(() => {
    if (['kraonhold', 'not_kyc', 'kraregistered', ''].includes(kycStatus)) {
      setKraFailuer(true);
    }
  }, [kycStatus]);

  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P') {
          if (!individualPanRegex.test(fieldValue))
            return createError({
              message: 'Invalid PAN',
              path,
            });
          if (individualPanRegex.test(fieldValue)) return true;
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'Invalid PAN',
            path,
          });
        }
        return true;
      }),

    name: yup.string().test('name', (value, context) => {
      const { path, createError } = context;
      if (!value && kraFailuer && !kraDetailsCaptured) {
        return createError({
          message: 'Name is required',
          path,
        });
      }
      return true;
    }),
    emailId: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value) && ENABLE_EMAIL_OTP,
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value),
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (!phoneRegExp.test(value) && kraFailuer && !kraDetailsCaptured) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!(kraFailuer && !kraDetailsCaptured)) {
          if (
            !isValidPhoneNumber(
              parent?.countryNameAndCode?.split(':')[1].trim() + value,
              codesList as CountryCode
            )
          ) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }
          return true;
        }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => (disablePOA ? true : !value),
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (
            parent.mobile &&
            !isValidPhoneNumber(
              value?.split(':')[1].trim() + parent.mobile,
              codesList as CountryCode
            )
          ) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
  });
  const initialValues1: MValues = {
    pan: pan,
    mobile: application?.topupInitiated ? application.applicants[index || 0].mobile : '',
    emailId: application?.topupInitiated ? application.applicants[index || 0].email || '' : '',
    bypassOtp: false,
    skipOtpModal: false,
    hasPOA: application?.topupInitiated || (id && redirectTo) ? application.hasPOA : false,
    dob: dob,
    countryCode: application?.topupInitiated
      ? application.applicants[index || 0].countryCode || ''
      : '+91',
    countryNameAndCode: application?.topupInitiated
      ? application.applicants[index || 0].countryNameAndCode || ''
      : 'India: +91',
    onboardingOtpEmailConsent: 'otp',
    kycStatus: kycStatus,
    kraVerification: kraVerification,
    name: '',
    aadhaarLinked: aadhaarLinked,
  };

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/application/distributor-details', { ...(res || {}) });
  };

  const handleSubmit1 = async (values: MValues) => {
    const {
      pan,
      mobile = '',
      bypassOtp = false,
      hasPOA,
      emailId,
      // eslint-disable-next-line
      countryCode = '+91',
      countryNameAndCode = 'India: +91',
      onboardingOtpEmailConsent = 'otp',
    } = values;
    const kFinCkycId = ckycResponse?.ckycId ? { kFinCkycId: ckycResponse?.ckycId } : {};
    if (hasPOA) {
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true, ...kFinCkycId })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      if (!application?.topupInitiated) {
        if (id && redirectTo) {
          (await dispatch(
            addJointHolder({ applicantVerificationToken }, id)
          )) as unknown as ApplicationProps;
          history.push(redirectTo, { id });
          return;
        } else {
          await handleCreateApplication(applicantVerificationToken);
        }
      } else {
        await dispatch(
          verifyApplicant(application.applicants[index || 0].id || 0, applicantVerificationToken)
        );
        if (index != application.applicants.length - 1) {
          return history.push('enter-pan-number', {
            application: application,
            firstHolderName: getFirstHolderName(application.applicants),
            index: (index || 0) + 1,
            fromTopUp,
          });
        } else {
          return history.push(`/application`, {
            id: application.topupId,
            topUpApplication: application.topupInitiated,
          });
        }
      }
      // }
      return;
    }
    if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
      (await dispatch(
        sendConsentEmail({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          applicationId: id || '',
          ...kFinCkycId,
        })
      )) as unknown as SendConsentEmailResponseBody;
      enqueueSnackbar('Email sent successfully', {
        variant: 'success',
        autoHideDuration: 3000,
      });
      return history.push(
        [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
          ? `/applications-list`
          : '/applications'
      );
    }

    const response = (await dispatch(
      sendOtp({
        phoneNumber: mobile.trim(),
        emailId,
        panVerificationToken,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        countryNameAndCode,
        bypassOtp,
        ...kFinCkycId,
      })
    )) as unknown as SendOtpResponseBody;

    const { applicantVerificationToken, phoneNumber } = response || {};
    if (bypassOtp) {
      if (id && redirectTo && !application?.topupInitiated) {
        (await dispatch(
          addJointHolder({ applicantVerificationToken }, id)
        )) as unknown as ApplicationProps;
        history.push(redirectTo, { id });
        return;
      } else if (!application?.topupInitiated) {
        handleCreateApplication(applicantVerificationToken);
      } else if (application?.topupInitiated) {
        await dispatch(
          verifyApplicant(application.applicants[index || 0].id || 0, applicantVerificationToken)
        );
        if (index != application.applicants.length - 1) {
          return history.push('enter-pan-number', {
            application: application,
            firstHolderName: getFirstHolderName(application.applicants),
            index: (index || 0) + 1,
            fromTopUp,
          });
        } else {
          return history.push(`/application`, {
            id: application.topupId,
            topUpApplication: application.topupInitiated,
          });
        }
      }
      return;
    }
    history.push('enter-otp', {
      pan,
      unmaskedphone: mobile.trim(),
      umaskedemailId: emailId,
      mobile: phoneNumber,
      panVerificationToken,
      redirectTo,
      application,
      email: (response || {}).emailId,
      firstHolderName,
      countryCode: countryNameAndCode?.split(':')[1].trim(),
      countryNameAndCode,
      index: index,
      fromTopUp,
      ...(response || {}),
      ...kFinCkycId,
    });
  };

  useEffect(() => {
    // (async function () {
    //   const res = (await dispatch(
    //     IsApplicableForPOA()
    //   )) as unknown as IsApplicableForPOAResponseBody;
    //   const { powerOfAttorney } = res;
    setDisablePOA(
      application
        ? application.hasPOA
          ? application.hasPOA
          : !application.hasPOA
        : !powerOfAttorney
    );
    // })();
  }, []);

  // ✅ Called when dialog form succeeds
  const handleKraDialogSuccess = async (ckycPayload: SendCkycPayload) => {
    const response = (await dispatch(DoCkyc(ckycPayload))) as unknown as SendCkycResponse;
    setCkycResponse(response);
    setKraDetailsCaptured(true);
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={(values) =>
          !kraDetailsCaptured && kraFailuer
            ? handleKraDialogSuccess({
                dob: new Date(values.dob).toISOString().split('T')[0],
                email: values.emailId,
                mobile: values.mobile || '',
                name: values.name,
                pan: values.pan,
              })
            : handleSubmit1(values)
        }>
        {({
          handleSubmit,
          values,
          validateForm,
          isSubmitting,
          setTouched,
          setErrors,
          setFieldValue,
        }) => (
          <Box>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <Box sx={{ position: 'relative' }}>
                <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                  <CardMedia
                    component="img"
                    src="/images/tick.svg"
                    sx={{ width: '18px', float: 'right' }}
                  />
                </Box>
                <MFTextField
                  label="PAN"
                  name="pan"
                  placeholder="Enter PAN"
                  required
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  disabled={true}
                  applyMarginBottom={false}
                />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: 'rgba(35, 133, 63, 0.7)', mb: 0.5 }}>
                  <Typography
                    variant="body2"
                    component={'span'}
                    sx={{
                      fontWeight: 600,
                      color:
                        values.kraVerification === 'success' ? 'rgba(35, 133, 63, 0.7)' : '#BD2932',
                      mb: 0.5,
                    }}>
                    {values.kraVerification === 'success'
                      ? 'KYC Verified, '
                      : 'KYC Verification Failed, '}
                  </Typography>
                  <Typography
                    variant="body2"
                    component={'span'}
                    sx={{
                      fontWeight: 600,

                      color: amlCheck ? 'rgba(35, 133, 63, 0.7)' : '#BD2932',

                      mb: 0.5,
                    }}>
                    AML Check {amlCheck ? 'Passed' : 'Failed'}
                  </Typography>
                  <Typography
                    variant="body2"
                    component={'span'}
                    sx={{
                      fontWeight: 600,
                      color: values.aadhaarLinked ? 'rgba(35, 133, 63, 0.7)' : '#BD2932',
                      mb: 0.5,
                    }}>
                    {values.aadhaarLinked ? ', Pan Aadhaar Linked' : ', Pan Aadhaar Not Linked'}
                  </Typography>
                </Typography>
                {IS_DOB_APPLICABLE_FOR_AMC && (
                  <TextDatePicker
                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                    label={'Date of birth'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'Enter Date of birth'}
                    name="dob"
                    disabled={true}
                  />
                )}

                {(!kraFailuer || (kraFailuer && kraDetailsCaptured)) && (
                  <MFCheckbox
                    name="hasPOA"
                    label="Power of Attorney"
                    color="primary"
                    sx={{
                      '.MuiTypography-root': {
                        color: 'primary.main',
                        fontWeight: 500,
                        fontSize: 14,
                        letterSpacing: '0.9625px',
                      },
                    }}
                    disabled={
                      disablePOA || application?.topupInitiated || !!application?.id || false
                    }
                  />
                )}
              </Box>
              {kraFailuer && !kraDetailsCaptured && (
                <MFTextField
                  label="Name"
                  name="name"
                  placeholder="Enter Name"
                  required
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  disabled={kraDetailsCaptured}
                  applyMarginBottom={false}
                />
              )}
              {values.kycStatus && (
                <MFSelectField
                  name={`kycStatus`}
                  label="KRA Status"
                  items={Object.keys(KRA_STATUS_MASTER).map((item) => ({
                    key: KRA_STATUS_MASTER[item],
                    value: item,
                  }))}
                  disabled={true}
                />
              )}
              <Box sx={{ my: kraDetailsCaptured ? 2 : 0 }}>
                <KYCCompletionLink ckycRedirectUrl={ckycResponse.redirectUrl} />
              </Box>
              {(!values.hasPOA || (kraFailuer && !kraDetailsCaptured)) && (
                <>
                  {kraFailuer && !kraDetailsCaptured ? (
                    <MFTextField
                      name="mobile"
                      label="Mobile Number"
                      placeholder="Enter Mobile Number"
                      regexForFilterValue={nonDigitRegex}
                    />
                  ) : (
                    <MobileNumberField
                      label={'Mobile Number'}
                      name={`mobile`}
                      placeholder="Enter Mobile number"
                      onKeyDown={(e) => {
                        preventSpecialCharacters(e);
                      }}
                      countryCodeFieldName={'countryNameAndCode'}
                      countryCodeValue={values.countryNameAndCode}
                      regexForFilterValue={nonDigitRegex}
                      disabled={application?.topupInitiated || kraDetailsCaptured || false}
                    />
                  )}
                  {ENABLE_EMAIL_OTP && (
                    <MFTextField
                      autoComplete="off"
                      // autoFocus
                      label="Email ID"
                      name="emailId"
                      placeholder="Enter Email ID"
                      required
                      disabled={application?.topupInitiated || kraDetailsCaptured || false}
                    />
                  )}
                  {!values.hasPOA &&
                    (!kraFailuer || (kraFailuer && kraDetailsCaptured)) &&
                    ENABLE_Email_Consent &&
                    !application?.topupInitiated && (
                      <UseRadioGroup
                        formLabel=""
                        name={`onboardingOtpEmailConsent`}
                        defaultValue="otp"
                        items={Object.keys(ONBOARDING_OPTIONS)
                          // .filter((item) =>
                          //   application?.topupInitiated
                          //     ? ONBOARDING_OPTIONS[item] != ONBOARDING_OPTIONS.email_consent
                          //     : item
                          // )
                          .map((option) => ({
                            label: ONBOARDING_OPTIONS[option],
                            value: option,
                          }))}
                      />
                    )}
                  {!kraFailuer && kraDetailsCaptured && (
                    <Notes
                      displayContent={
                        'Provide the mobile phone number which is registered in KRA database. Applicants Identity details will be fetched from the KRA database.'
                      }
                    />
                  )}
                </>
              )}

              <MFSubmitButton
                label={
                  kraFailuer && !kraDetailsCaptured
                    ? 'Genrate KRA Link'
                    : values.hasPOA
                    ? 'Continue'
                    : ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                      ONBOARDING_OPTIONS.email_consent
                    ? 'Send Email'
                    : 'Get OTP'
                }
              />
              {!values.hasPOA &&
                (!kraFailuer || (kraFailuer && kraDetailsCaptured)) &&
                ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                  ONBOARDING_OPTIONS.otp && (
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      color: 'primary.main',
                      fontWeight: 500,
                      fontSize: 14,
                      mt: 0.5,
                      lineHeight: 1.5,
                    }}
                    onClick={async () => {
                      const error = await validateForm();
                      if (Object.keys(error).length) {
                        setTouched(setNestedObjectValues(error, true));
                        setErrors(error);
                        return;
                      }
                      setFieldValue('skipOtpModal', true);
                    }}>
                    Skip OTP Verification
                  </Button>
                )}
              <Dialog
                open={values.skipOtpModal}
                onClose={() => setFieldValue('skipOtpModal', false)}>
                <Box
                  sx={{
                    borderRadius: '10px',
                    // width: { xs: '70%', sm: '70%' },
                    maxWidth: 800,
                    height: { xs: '90%', md: 'unset' },
                    overflowY: 'auto',
                  }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 3,
                      '& .MuiButton-root': {
                        minWidth: 200,
                        fontSize: 16,
                      },
                    }}>
                    <IconButton
                      onClick={() => setFieldValue('skipOtpModal', false)}
                      sx={{ alignSelf: 'flex-end' }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                    {/* <Box sx={{ mb: 4 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box> */}
                    <Typography
                      sx={{
                        fontSize: 20,
                        fontWeight: 500,
                        color: '#337FC9',
                        textAlign: 'center',
                        mb: 5,
                        width: '90%',
                      }}>
                      Are you sure you want to Skip OTP Verification?
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-around',
                        width: '100%',
                      }}>
                      <Button
                        variant="outlined"
                        disabled={isSubmitting}
                        onClick={() => setFieldValue('skipOtpModal', false)}
                        sx={{ color: 'primary.main', mb: 2 }}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        sx={{ mb: 2 }}
                        onClick={() => {
                          setFieldValue('bypassOtp', true);
                          handleSubmit();
                        }}>
                        Continue
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Dialog>
            </Box>
          </Box>
        )}
      </Formik>
    </>
  );
}

export function EnterEmailId({
  location,
}: {
  location: Location<{
    panVerificationToken: string;
    pan: string;
    dob: string;
    amlCheck: boolean;
    powerOfAttorney: boolean;
    application: ApplicationProps;
    index: number;
    kycStatus: string;
    kraVerification: string;
  }>;
}): JSX.Element {
  const {
    panVerificationToken,
    pan,
    dob,
    amlCheck = false,
    powerOfAttorney = false,
    application,
    index = 0,
    kycStatus = '',
    kraVerification = '',
  } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);

  const [kraDetailsCaptured, setKraDetailsCaptured] = useState(false);
  const [ckycResponse, setCkycResponse] = useState<SendCkycResponse>({
    ckycId: null,
    redirectUrl: '',
  });
  const [kraFailuer, setKraFailuer] = useState(false);

  // 🔥 Open dialog immediately on page load
  useEffect(() => {
    if (['kraonhold', 'not_kyc', 'kraregistered', ''].includes(kycStatus)) {
      setKraFailuer(true);
    }
  }, [kycStatus]);
  // ✅ Called when dialog form succeeds
  const handleKraDialogSuccess = async (ckycPayload: SendCkycPayload) => {
    const response = (await dispatch(DoCkyc(ckycPayload))) as unknown as SendCkycResponse;
    setCkycResponse(response);
    setKraDetailsCaptured(true);
  };
  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P') {
          if (!individualPanRegex.test(fieldValue))
            return createError({
              message: 'Invalid PAN',
              path,
            });
          if (individualPanRegex.test(fieldValue)) return true;
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'Invalid PAN',
            path,
          });
        }
        return true;
      }),

    name: yup.string().test('name', (value, context) => {
      const { path, createError } = context;
      if (!value && kraFailuer && !kraDetailsCaptured) {
        return createError({
          message: 'Name is required',
          path,
        });
      }
      return true;
    }),
    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value),
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        if (!value && kraFailuer && !kraDetailsCaptured) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (value && !phoneRegExp.test(value) && kraFailuer && !kraDetailsCaptured) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        return true;
      }),
    }),
    emailId: yup.string().when('hasPOA', {
      is: (hasPOA: boolean) => (disablePOA ? true : !hasPOA),
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),
  });
  const initialValues1: EValues = {
    pan: pan,
    emailId: application?.topupInitiated ? application.applicants[index].email || '' : '',
    dob: dob,
    hasPOA: application?.topupInitiated ? application.hasPOA : false,
    kycStatus: kycStatus,
    kraVerification: kraVerification,
    name: '',
    countryCode: '',
    countryNameAndCode: '',
    mobile: '',
  };

  useEffect(() => {
    setDisablePOA(!powerOfAttorney);
  }, []);

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/non-individual-application', { ...(res || {}) });
  };

  const handleSubmit1 = async (values: EValues) => {
    const { emailId, hasPOA } = values;
    const kFinCkycId = ckycResponse?.ckycId ? { kFinCkycId: ckycResponse?.ckycId } : {};
    if (hasPOA) {
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true, ...kFinCkycId })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      if (!application?.topupInitiated) {
        await handleCreateApplication(applicantVerificationToken);
      } else {
        await dispatch(
          verifyApplicant(application.applicants[index || 0].id || 0, applicantVerificationToken)
        );
        history.push(`/non-individual-application`, {
          id: application.id,
          topUpApplication: application.topupInitiated,
        });
      }
      return;
    }
    const response = (await dispatch(
      SendEmail({ panVerificationToken, emailId, ...kFinCkycId })
    )) as unknown as VerifyOtpResponseBody;
    const { applicantVerificationToken } = response || {};
    if (!application?.topupInitiated) {
      await handleCreateApplication(applicantVerificationToken);
    } else {
      await dispatch(
        verifyApplicant(application.applicants[index || 0].id || 0, applicantVerificationToken)
      );
      history.push(`/non-individual-application`, {
        id: application.id,
        topUpApplication: application.topupInitiated,
      });
    }
    // history.push('verify-documents', {
    //   applicantVerificationToken,
    // });
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        enableReinitialize={true}
        onSubmit={(values) =>
          !kraDetailsCaptured && kraFailuer
            ? handleKraDialogSuccess({
                dob: new Date(values.dob).toISOString().split('T')[0],
                email: values.emailId,
                mobile: values.mobile || '',
                name: values.name,
                pan: values.pan,
              })
            : handleSubmit1(values)
        }>
        {({ handleSubmit, values }) => (
          <Box>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <Box sx={{ position: 'relative' }}>
                <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                  <CardMedia
                    component="img"
                    src="/images/tick.svg"
                    sx={{ width: '18px', float: 'right' }}
                  />
                </Box>
                <MFTextField
                  label="PAN"
                  name="pan"
                  placeholder="Enter PAN"
                  required
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  disabled={true}
                />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: 'rgba(35, 133, 63, 0.7)', mb: 0.5 }}>
                  <Typography
                    variant="body2"
                    component={'span'}
                    sx={{
                      fontWeight: 600,
                      color:
                        values.kraVerification === 'success' ? 'rgba(35, 133, 63, 0.7)' : '#BD2932',
                      mb: 0.5,
                    }}>
                    {values.kraVerification === 'success'
                      ? 'KYC Verified, '
                      : 'KYC Verification Failed, '}
                  </Typography>
                  <Typography
                    variant="body2"
                    component={'span'}
                    sx={{
                      fontWeight: 600,

                      color: amlCheck ? 'rgba(35, 133, 63, 0.7)' : '#BD2932',

                      mb: 0.5,
                    }}>
                    AML Check {amlCheck ? 'Passed' : 'Failed'}
                  </Typography>
                </Typography>
                {IS_DOB_APPLICABLE_FOR_AMC && (
                  <TextDatePicker
                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                    label={'Date of Birth/Incorporation'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'Enter Date of birth'}
                    name="dob"
                    disabled={true}
                  />
                )}
              </Box>
              {(!kraFailuer || (kraFailuer && kraDetailsCaptured)) && (
                <MFCheckbox
                  name="hasPOA"
                  label="Power of Attorney"
                  color="primary"
                  sx={{
                    '.MuiTypography-root': {
                      color: 'primary.main',
                      fontWeight: 500,
                      fontSize: 14,
                      letterSpacing: '0.9625px',
                    },
                  }}
                  disabled={disablePOA || application?.topupInitiated || false}
                />
              )}
              {kraFailuer && !kraDetailsCaptured && (
                <MFTextField
                  label="Name"
                  name="name"
                  placeholder="Enter Name"
                  required
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  disabled={kraDetailsCaptured}
                  applyMarginBottom={false}
                />
              )}
              {values.kycStatus && (
                <MFSelectField
                  name={`kycStatus`}
                  label="KRA Status"
                  items={Object.keys(KRA_STATUS_MASTER).map((item) => ({
                    key: KRA_STATUS_MASTER[item],
                    value: item,
                  }))}
                  disabled={true}
                />
              )}
              <Box sx={{ my: kraDetailsCaptured ? 2 : 0 }}>
                <KYCCompletionLink ckycRedirectUrl={ckycResponse.redirectUrl} />
              </Box>
              {kraFailuer && !kraDetailsCaptured && (
                <MFTextField
                  name="mobile"
                  label="Mobile Number"
                  placeholder="Enter Mobile Number"
                  regexForFilterValue={nonDigitRegex}
                  disabled={application?.topupInitiated || kraDetailsCaptured || false}
                />
                // <MobileNumberField
                //   label={'Mobile Number'}
                //   name={`mobile`}
                //   placeholder="Enter Mobile number"
                //   onKeyDown={(e) => {
                //     preventSpecialCharacters(e);
                //   }}
                //   countryCodeFieldName={'countryNameAndCode'}
                //   countryCodeValue={values.countryNameAndCode}
                //   regexForFilterValue={nonDigitRegex}
                //   disabled={application?.topupInitiated || kraDetailsCaptured || false}
                // />
              )}
              {(!values.hasPOA || kraFailuer) && (
                <>
                  <MFTextField
                    autoComplete="off"
                    autoFocus
                    label="Contact Person Email ID"
                    name="emailId"
                    placeholder="Enter Contact Person Email ID"
                    required
                    disabled={application?.topupInitiated || kraDetailsCaptured || false}
                  />
                  {!kraFailuer && kraDetailsCaptured && (
                    <Notes
                      displayContent={
                        'Based on registered email id, we will fetch the documents available with our MF holding that are serviced by kfintech and the data will be prefilled in the application.'
                      }
                    />
                  )}
                </>
              )}
              <MFSubmitButton
                label={kraFailuer && !kraDetailsCaptured ? 'Genrate KRA Link' : 'Proceed'}
              />
            </Box>
          </Box>
        )}
      </Formik>
    </>
  );
}
